import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const DiskCapacityBarMaxCapacity = styled.div<React.CSSProperties>`
  color: ${Colors['light']};
  font-family: ${Fonts['regular']};
  font-size: ${28 * Screen.widthRatio}px;
  position: absolute;
  top: ${-40 * Screen.widthRatio}px;
  right: ${20 * Screen.widthRatio}px;
`;

export default DiskCapacityBarMaxCapacity;
